//export const baseUrl = "http://10.40.55.28:6005"
export const baseUrl = "https://hccapi.mobifone5.vn/chatbotshlx"
//export const baseUrl = "https://watersupply.mobifone5.vn/chatbot"
export default {
    baseUrl
}
